import { Injectable } from '@angular/core';

var geoParse = require('wellknown');
import * as turf from '@turf/turf';
import { Cartesian3, EllipsoidGeodesic, Ellipsoid, Math as CesiumMath } from 'cesium';
import * as Cesium from 'cesium';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import * as ct from 'countries-and-timezones'; // <-- import the library
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  private operatorEula: { [itemName: string]: string } = {
    'Head': '/assets/files/EULA/EULA-pdf/HEAD-CG.pdf',
    'Capella': '/assets/files/EULA/EULA-pdf/Capella.pdf',
    'Satellogic': '/assets/files/EULA/EULA-pdf/Satellogic.pdf',
    '21AT': '/assets/files/EULA/EULA-pdf/21AT.pdf',
    'Umbra': '/assets/files/EULA/EULA-pdf/Umbra.pdf',
    'STE': '/assets/files/EULA/EULA-pdf/STE.pdf',
    'KOMPSAT': '/assets/files/EULA/EULA-pdf/Kompsat.pdf',
    'USL': '/assets/files/EULA/EULA-pdf/USL.pdf',
    'ISI' : '/assets/files/EULA/EULA-pdf/ISI.pdf',
    'GHG' : '/assets/files/EULA/EULA-pdf/GHG.pdf',
    'Ororatech': '/assets/files/EULA/EULA-pdf/OroraTech.pdf',
    'SatVu': '/assets/files/EULA/EULA-pdf/SATVU.pdf',
    'Blacksky': '/assets/files/EULA/EULA-pdf/BlackSky-ING.pdf',
    'BlackSky-Commercial' : '/assets/files/EULA/EULA-pdf/BlackSky-COMMERCIAL.pdf',
    'Wyvern': '/assets/files/EULA/EULA-pdf/Wyvern.pdf',
    'Spire': '/assets/files/EULA/EULA-pdf/Spire.pdf',
    'AxelSpace-Academic': '/assets/files/EULA/EULA-pdf/Axel-Academic.pdf',
    'AxelSpace-Media': '/assets/files/EULA/EULA-pdf/Axel-Media.pdf',
    'AxelSpace-Common': '/assets/files/EULA/EULA-pdf/Axel-Common.pdf',
    'ClydeSpace': '/assets/files/EULA/EULA-pdf/Clyde.pdf',
    'Gokturk': '/assets/files/EULA/EULA-pdf/Gokturk.pdf',
    'ECURS': '/assets/files/EULA/EULA-pdf/ECURS.pdf',
    'ECURS_L': '/assets/files/EULA/EULA-pdf/ECURS.pdf',
    'Esper': 'https://creativecommons.org/licenses/by/4.0/legalcode.en/',
    'OSK': '/assets/files/EULA/EULA-pdf/OSK.pdf',
    'Spire-RF': '/assets/files/EULA/EULA-pdf/Spire-RF.pdf',
    'STE_TELEOS': '/assets/files/EULA/EULA-pdf/STE.pdf',
    'Pixxel': '/assets/files/EULA/EULA-pdf/Pixxel.pdf',
    'Azista': '/assets/files/EULA/EULA-pdf/Azista.pdf',
    'SatelliteVu_VanZyl': '/assets/files/EULA/EULA-pdf/Hydrostat.pdf',
  };

  private operatorEulaSites: { [itemName: string]: string } = {
    'Head': '/assets/files/EULA/EULA-pdf/HEAD-CG.pdf',
    'Capella': '/assets/files/EULA/EULA-pdf/Capella.pdf',
    'Satellogic': '/assets/files/EULA/EULA-pdf/Satellogic.pdf',
    '21AT': '/assets/files/EULA/EULA-pdf/21AT.pdf',
    'Umbra': '/assets/files/EULA/EULA-pdf/Umbra.pdf',
    'STE': '/assets/files/EULA/EULA-pdf/STE.pdf',
    'KOMPSAT': '/assets/files/EULA/EULA-pdf/Kompsat.pdf',
    'USL': '/assets/files/EULA/EULA-pdf/USL.pdf',
    'ISI' : '/assets/files/EULA/EULA-pdf/ISI.pdf',
    'GHG' : '/assets/files/EULA/EULA-pdf/GHG.pdf',
    'Ororatech': '/assets/files/EULA/EULA-pdf/OroraTech.pdf',
    'SatVu': '/assets/files/EULA/EULA-pdf/SATVU.pdf',
    'Blacksky': '/assets/files/EULA/EULA-pdf/BlackSky-ING.pdf',
    'BlackSky-Commercial' : '/assets/files/EULA/EULA-pdf/BlackSky-COMMERCIAL.pdf',
    'Wyvern': '/assets/files/EULA/EULA-pdf/Wyvern.pdf',
    'Spire': '/assets/files/EULA/EULA-pdf/Spire.pdf',
    'AxelSpace-Academic': '/assets/files/EULA/EULA-pdf/Axel-Academic.pdf',
    'AxelSpace-Media': '/assets/files/EULA/EULA-pdf/Axel-Media.pdf',
    'AxelSpace-Common': '/assets/files/EULA/EULA-pdf/Axel-Common.pdf',
    'ClydeSpace': '/assets/files/EULA/EULA-pdf/Clyde.pdf',
    'Gokturk': '/assets/files/EULA/EULA-pdf/Gokturk.pdf',
    'ECURS': '/assets/files/EULA/EULA-pdf/ECURS.pdf',
    'ECURS_L': '/assets/files/EULA/EULA-pdf/ECURS.pdf',
    'Esper': 'https://creativecommons.org/licenses/by/4.0/legalcode.en/',
    'OSK': '/assets/files/EULA/EULA-pdf/OSK.pdf',
    'Spire-RF': '/assets/files/EULA/EULA-pdf/Spire-RF.pdf',
    'STE_TELEOS': '/assets/files/EULA/EULA-pdf/STE.pdf',
    'Pixxel': '/assets/files/EULA/EULA-pdf/Pixxel.pdf',
    'Azista': '/assets/files/EULA/EULA-pdf/Azista.pdf',
    'SatelliteVu_VanZyl': '/assets/files/EULA/EULA-pdf/Hydrostat.pdf'
  };

  htmlContent: string;
  aoiData: any;
  htmlEulaContent: string;
    
  constructor(private apiService: ApiService) {}

  // Function to check if a given latitude is within the range
  isLatitudeInRange(target: any, minValue: number, maxValue: number, cueing:boolean = false): boolean {
    let geoJSON: any;
    if (cueing && target.geoJSONCue) {
      geoJSON = geoParse(target.geoJSONCue);
    } else {
      geoJSON = geoParse(target.geoJSON);
    }
    
    if (target?.multiTarget?.length > 0) {
      for (const targets of target.multiTarget) {
        const geoJson = geoParse(targets);
        const latitude = geoJson.coordinates[1];
        if (latitude >= minValue && latitude <= maxValue) {
          return true; // If any latitude is within the range, return true
        }
      }
    } else if (geoJSON.type === 'Point') {
      const latitude = geoJSON.coordinates[1];
      return latitude >= minValue && latitude <= maxValue;
    } else if (geoJSON.type === 'Polygon') {
      const coordinates = geoJSON.coordinates[0];
      for (const coordinate of coordinates) {
        const latitude = coordinate[1];
        if (latitude >= minValue && latitude <= maxValue) {
          return true; // If any latitude is within the range, return true
        }
      }
    }
    return false;
  }

  // Function to check if a point is inside a polygon
  pointInPolygon(point, polygon) {
    var x = point[0], y = point[1];
    var inside = false;
    for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        var xi = polygon[i][0], yi = polygon[i][1];
        var xj = polygon[j][0], yj = polygon[j][1];
        
        var intersect = ((yi > y) != (yj > y)) &&
            (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
  }

  // Function to check if one polygon is inside another
  polygonInsidePolygon(polygon1, polygon2) {
    for (var i = 0; i < polygon1.length; i++) {
        if (!this.pointInPolygon(polygon1[i], polygon2)) {
            return false;
        }
    }
    return true;
  }

  // Function to check if two polygons are the same
  polygonsAreSame(polygon1, polygon2) {
    let tolerance = 1e-6; //maximum allowed difference between corresponding coordinates.
    if (polygon1.length !== polygon2.length) {
        return false;
    }

    for (var i = 0; i < polygon1.length; i++) {
      const dx = Math.abs(polygon1[i][0] - polygon2[i][0]);
      const dy = Math.abs(polygon1[i][1] - polygon2[i][1]);
      
      if (dx > tolerance || dy > tolerance) {
          return false;
      }
  }
    
    return true;
  }

  // Function to check if one polygon is inside another or if they are the same
  comparePolygons(polygon1, polygon2) {
    if (this.polygonInsidePolygon(polygon1, polygon2)) {
        return true;
    } else if (this.polygonsAreSame(polygon1, polygon2)) {
        return true;
    } else {
        return false;
    }
  }

  getPdfUrl(operatorKey: string): string {
    return this.operatorEula[operatorKey] || '';
  }

  getEulaSiteUrl(operatorKey: string): string {
    return this.operatorEulaSites[operatorKey] || '';
  }

  getContent(): string {
    return this.htmlContent;
  }

  setContent(newContent: string): void {
    this.htmlContent = newContent;
  }

  setEULAContent(newContent: string): void {
    this.htmlEulaContent = newContent;
  }

  getEulaContent(): string {
    return this.htmlEulaContent;
  }
  
  // Function to check if every side of the polygon is greater than or equal to minLength; returns false if any side is shorter
  calculateMinSwathWidth(aoi: any, minLength:number = 5) {
    this.aoiData = geoParse(aoi)    
    const coordinates = this.aoiData.coordinates[0];
    let minDistance = Number.MAX_VALUE;

    // Calculate distances between consecutive points
    for (let i = 0; i < coordinates.length - 1; i++) {
      const coord1 = coordinates[i];
      const coord2 = coordinates[i + 1];
      const distance = this.calculateDistance(coord1[1], coord1[0], coord2[1], coord2[0]); // Reversed lat-long order
      if (distance < minDistance) {
        minDistance = distance;
      }
    }

    // Check if minimum width meets the requirement
    let minSwathWidth = minDistance;
    return minDistance >= minLength;
  }

  /**
   * Calculates the maximum distance between consecutive vertices of a polygon.
   * Returns true if the longest side is less than or equal to the given maxLength,
   * otherwise returns false.
   */
  calculateMaxSwathWidth(aoi: any, maxLength: number = 25) {
    this.aoiData = geoParse(aoi);
    const coordinates = this.aoiData.coordinates[0];

    let maxDistance = 0;

    // Calculate distances between consecutive points
    for (let i = 0; i < coordinates.length - 1; i++) {
      const coord1 = coordinates[i];
      const coord2 = coordinates[i + 1];

      const distance = this.calculateDistance(coord1[1], coord1[0], coord2[1], coord2[0]); // Reversed lat-long
      if (distance > maxDistance) {
        maxDistance = distance;
      }
    }

    console.log('maxDistance', maxDistance);

    // Check if maximum width exceeds the limit
    return maxDistance <= maxLength;
  }


  calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const earthRadius = 6371; // Earth's radius in kilometers
    const dLat = this.degreesToRadians(lat2 - lat1);
    const dLon = this.degreesToRadians(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.degreesToRadians(lat1)) * Math.cos(this.degreesToRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c;
    return distance;
  }

  degreesToRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
  }

  calculateMaxWidth(aoi: any) {
    this.aoiData = geoParse(aoi)
    const coordinates = this.aoiData.coordinates[0];
    let maxDistance = 0;

    // Calculate distances between consecutive points
    for (let i = 0; i < coordinates.length - 1; i++) {
      const coord1 = coordinates[i];
      const coord2 = coordinates[i + 1];
      const distance = this.calculateDistance(coord1[1], coord1[0], coord2[1], coord2[0]); // Reversed lat-long order
      if (distance > maxDistance) {
        maxDistance = distance;
      }
    }

    return maxDistance > 5;
  }

  calculateArea(pointArray: string[]): number {  
    const coordinates = pointArray.map(point => this.parsePoint(point));
    
    // Sort coordinates in counter-clockwise order
    const orderedCoordinates = this.sortPointsCounterClockwise(coordinates);
  
    let totalArea = this.calculateAreaUsingTurf(orderedCoordinates);
    totalArea = totalArea / 1e6;
    return totalArea;
  }
  
  parsePoint(point: string): [number, number] {
    const coords = point.replace('POINT (', '').replace(')', '').split(' ');
    return [parseFloat(coords[0]), parseFloat(coords[1])];
  }
  
  sortPointsCounterClockwise(points: [number, number][]): [number, number][] {
    // Calculate the centroid
    const centroid = turf.centroid(turf.multiPoint(points)).geometry.coordinates;
  
    // Sort points by angle with respect to the centroid
    return points.sort((a, b) => {
      const angleA = Math.atan2(a[1] - centroid[1], a[0] - centroid[0]);
      const angleB = Math.atan2(b[1] - centroid[1], b[0] - centroid[0]);
      return angleA - angleB;
    });
  }
  
  calculateAreaUsingTurf(points: [number, number][]): number {
    const coordinatesWithClosure = [...points, points[0]]; // Close the polygon by adding the first point at the end
    const polygon = turf.polygon([coordinatesWithClosure]);
    return turf.area(polygon);
  }
  
  convertCostToPoints(cost:any,sensorConversionFactor) {
    const parts = sensorConversionFactor.split(':');      
    const conversionFactor =  parseFloat(parts[1]) / parseFloat(parts[0]);
    let points =  Math.round(cost * conversionFactor);
    return points;
}

  // Extracts longitude and latitude from the 'POINT (lng lat)' format
  extractCoordinates(point: string) {
    const coords = point.match(/POINT \(([^ ]+) ([^ ]+)\)/);
    if (coords && coords.length === 3) {
      return {
        lng: parseFloat(coords[1]),
        lat: parseFloat(coords[2])
      };
    }
    throw new Error('Invalid point format');
  }

  getCirclePolygon(center, radius: number, numPoints: number = 64) {
    const positions: any = [];
    const geodesic = new EllipsoidGeodesic();

    // Convert center to Cartographic
    const centerCartographic = Cesium.Cartographic.fromDegrees(center.lng, center.lat);

    for (let i = 0; i < numPoints; i++) {
      const angle = CesiumMath.toRadians((360 / numPoints) * i); // Calculate angle for each point

      // Compute the point on the perimeter of the circle
      const perimeterPointCartographic = Ellipsoid.WGS84.cartesianToCartographic(
        Cartesian3.fromRadians(
          centerCartographic.longitude + radius / Ellipsoid.WGS84.maximumRadius * Math.cos(angle),
          centerCartographic.latitude + radius / Ellipsoid.WGS84.maximumRadius * Math.sin(angle)
        )
      );

      const longitude = CesiumMath.toDegrees(perimeterPointCartographic.longitude);
      const latitude = CesiumMath.toDegrees(perimeterPointCartographic.latitude);
      positions.push(`${longitude} ${latitude}`);
    }

    // Close the polygon by repeating the first point at the end
    positions.push(positions[0]);

    // Format the points into the POLYGON string
    const polygon = `POLYGON ((${positions.join(', ')}))`;
    return polygon;
  }

// Calculate the overlap percentage between two circles
calculateOverlapPercentage(distance: number, radius: number): number {
  const r = radius;
  const d = distance;

  // Handle cases where circles are too far apart or identical
  if (d >= 2 * r) return 0; // No overlap
  if (d === 0) return 100; // Identical circles

  // Area of intersection between two circles formula
  const part1 = r * r * Math.acos((d * d + r * r - r * r) / (2 * d * r));
  const part2 = r * r * Math.acos((d * d + r * r - r * r) / (2 * d * r));
  const part3 = 0.5 * Math.sqrt((-d + r + r) * (d + r - r) * (d - r + r) * (d + r + r));

  const overlapArea = part1 + part2 - part3;
  const circleArea = Math.PI * r * r;

  // Calculate the percentage of overlap relative to one circle's area
  return (overlapArea / circleArea) * 100;
}

checkIsItWater(locations) {
  this.apiService.checkIsWater(locations).subscribe((res: any) => {
    return res;
  });
}

sortPurposeOptions(purposeOption: any[]) {
  purposeOption = purposeOption.sort((a, b) => {
    if (!a.purpose) return 1; // If `a.purpose` is undefined, move it to the end
    if (!b.purpose) return -1; // If `b.purpose` is undefined, move it to the end

    if (a.purpose === 'Others') return 1; // Keep "Others" at the end
    if (b.purpose === 'Others') return -1; // Keep "Others" at the end

    return a.purpose.localeCompare(b.purpose); // Sort alphabetically by purpose
  });
  
  return purposeOption; // return sorted array if needed
}

getGST(currentUser: any) {
  let GST = 0;
  if (
    currentUser?.channelPriceId === undefined &&
    currentUser?.country === 'Singapore'
  ) {
    GST = environment.gst;
    return GST;
  } else if (currentUser?.channelPriceId != undefined) {
    GST = currentUser?.tax[0]?.taxperc;
    return GST;
  }
  
  return GST;
}

calculateGST(amount,user) {
  let gst = this.getGST(user);
  let value = (amount * gst) / 100;
  return value;
}

calculateAdditionalCharges(amount,onlineFees) {
  let totalAmount = amount / onlineFees;
  let value = (totalAmount - amount);
  return value;
}

shipColors = [
  { type: 'CONTAINER', color: 'Red' },
  { type: 'DREDGER', color: 'darkgreen' },
  { type: 'DRY_BULK', color: 'Blue' },
  { type: 'HIGH_SPEED_CRAFT', color: '#25aae0' },
  { type: 'LIVESTOCK', color: '#008B8B' },
  { type: 'MILITARY_OPS', color: 'RoyalBlue' },
  { type: 'SEARCH_AND_RESCUE', color: 'Brown' },
  { type: 'LAW_ENFORCEMENT', color: '#ac9103' },
  { type: 'TANKER_CRUDE', color: '#A0522D' },
  { type: 'TANKER_CHEMICALS', color: 'Plum' },
  { type: 'TANKER_PRODUCT', color: '#BC8F8F' },
  { type: 'GENERAL_TANKER', color: 'Aqua' },
  { type: 'TUG', color: '#6c4adc' },
  { type: 'PASSENGER', color: 'DeepPink' },
  { type: 'FISHING', color: 'Violet' },
  { type: 'GENERAL_CARGO', color: '#9ce49c' },
  { type: 'OTHER', color: 'Yellow' },
  { type: 'PLEASURE_CRAFT', color: '#6B8E23' },
  { type: 'SAILING', color: 'Purple' }
];

getShipColor = (shipType: string): string => {
  const ship = this.shipColors.find(s => s.type === shipType);
  return ship ? ship.color : 'Yellow';
};

getShips() {
  return this.shipColors;
}

historiaclShipColors = [
  { type: 'CONTAINER', color: 'Red' },
  { type: 'DREDGER', color: 'darkgreen' },
  { type: 'DRY_BULK', color: 'Blue' },
  { type: 'HIGH_SPEED_CRAFT', color: '#25aae0' },
  { type: 'LIVESTOCK', color: '#008B8B' },
  { type: 'MILITARY_OPS', color: 'RoyalBlue' },
  { type: 'SEARCH_AND_RESCUE', color: 'Brown' },
  { type: 'LAW_ENFORCEMENT', color: '#ac9103' },
  { type: 'TANKER_CRUDE', color: '#A0522D' },
  { type: 'TANKER_CHEMICALS', color: 'Plum' },
  { type: 'TANKER_PRODUCT', color: '#BC8F8F' },
  { type: 'GENERAL_TANKER', color: 'Aqua' },
  { type: 'TUG', color: '#6c4adc' },
  { type: 'PASSENGER', color: 'DeepPink' },
  { type: 'FISHING', color: 'Violet' },
  { type: 'GENERAL_CARGO', color: '#9ce49c' },
  { type: 'OTHER', color: 'Yellow' },
  { type: 'PLEASURE_CRAFT', color: '#6B8E23' },
  { type: 'SAILING', color: 'Purple' }
]

getHistoricalShipColor = (shipType: string): string => {
  const ship = this.historiaclShipColors.find(s => s.type === shipType);
  return ship ? ship.color : 'Yellow';
};

getHistoricalShips() {
  return this.historiaclShipColors;
}

  getCompassDirection(course) {
    const directions = [
      "N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE",
      "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"
    ];

    // Normalize course value to 0-360
    course = ((course % 360) + 360) % 360;

    // Find the index in the directions array
    let index = Math.round(course / 22.5) % 16;
    return directions[index];
  }

  getVesselDirection(direction) {
    const leftToRight = [
      ["ESE", "E", "N", "ENE", "SSE", "SE","NE","WSW","NNE"]    
  ];

  const rightToLeft = [  
      ["S", "W", "SW","NW","NNW",,"WNW","SSW"]   
  ];

  if (leftToRight.some(row => row.includes(direction))) {
      return "LR";
  } else if (rightToLeft.some(row => row.includes(direction))) {
      return "RL";
  } else {
      return "RL";
  }
}

keyPressValidation(event: any) {
  let value = event.target.value;

  // Capitalize first character
  if (value.length === 0 && event.key.length === 1) {
    event.target.value = event.key.toUpperCase();
    event.preventDefault();
  }

  const pattern = /[A-Za-z\s\W]/; // Allow letters, spaces, and special characters

  let inputChar = String.fromCharCode(event.charCode);

  if (
    (event.keyCode !== 8 && !pattern.test(inputChar)) ||  // Block invalid chars
    /[0-9]/.test(inputChar) ||                            // Block numbers
    value.length > 50                                      // Limit length
  ) {
    event.preventDefault();
  }
}

convertUtcToLocal(dateTime: string, currentUser: any) {
  const userTimezone = this.getTimezoneFromCountry(currentUser.country);

  if (!dateTime || !userTimezone) {
    return dateTime; // return the same UTC value instead of ''
  }
  
  return moment.utc(dateTime).tz(userTimezone).format('DD/MM/YYYY - hh.mm A');
}

getTimezoneFromCountry(countryName: string): string {
  const countryList = ct.getAllCountries();  
  for (const countryCode in countryList) {
    const country = countryList[countryCode];
    if (country.name.toLowerCase() === countryName.toLowerCase()) {
      // pick the first timezone
      return country.timezones[0];
    }
  }
  
  return moment.tz.guess(); // fallback to system timezone if not found
}

  getCurrentLocalTime(currentUser) {
    const userTimezone = this.getTimezoneFromCountry(currentUser.country);
    const currentLocalTime = moment().tz(userTimezone).format('HH:mm A');
    return currentLocalTime;
  }

checkForCurrentWeek(currentDate: Date, dayOfWeek: string, time: any, toiStart): boolean {
  const startDate: Date = moment(toiStart).utc().toDate();
  
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const currentDayIndex = currentDate.getUTCDay();
  const targetDayIndex = days.indexOf(dayOfWeek);

  // Convert current date to UTC
  const utcDate = new Date(currentDate.toUTCString());

  // Check if the current date is after the specified day and time
  const isAfterDayOfWeek =
    currentDayIndex > targetDayIndex ||
    (currentDayIndex === targetDayIndex && utcDate.getUTCHours() >= time);

    if (isAfterDayOfWeek) {
      // Get next week's Tuesday (set to 23:59:59 UTC)
      const nextTuesday = new Date(utcDate);
      nextTuesday.setUTCDate(utcDate.getUTCDate() + ((7 - currentDayIndex + targetDayIndex) % 7 || 7)); // Move to next Tuesday
      nextTuesday.setUTCHours(23, 59, 59, 999); // End of Tuesday
  
      // Check if startDate is after the end of next Tuesday
      return startDate < nextTuesday;
    }
  
    return false;
}

  getCurrentLocalDateTime(currentUser) {
    const userTimezone = this.getTimezoneFromCountry(currentUser.country);
    const currentLocalDateTime = moment().tz(userTimezone).format('YYYY-MM-DD hh:mm A');
    return currentLocalDateTime;
  }
    hasFeatureCheck(planDetails:any,featureKey: string): boolean { 
    return planDetails?.features?.some(feature => 
      feature.key.toLowerCase() === featureKey.toLowerCase()
    ) || false;
  }

  pointAllInPolygon(point, polygon) {
    const x = point[0], y = point[1];
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i][0], yi = polygon[i][1];
      const xj = polygon[j][0], yj = polygon[j][1];

      // Check if point is exactly on a vertex
      if (x === xi && y === yi) return true;

      // Check if point is on an edge
      const onEdge =
        (y - yi) * (xj - xi) === (x - xi) * (yj - yi) && // Collinear
        x >= Math.min(xi, xj) && x <= Math.max(xi, xj) &&
        y >= Math.min(yi, yj) && y <= Math.max(yi, yj);
      if (onEdge) return true;

      // Standard ray-casting
      const intersect = ((yi > y) !== (yj > y)) &&
        (x < ((xj - xi) * (y - yi)) / (yj - yi) + xi);

      if (intersect) inside = !inside;
    }

    return inside;
  }

  getGeoJsonData(data: string | number[][] | number[]): string {
    if (!data) return '';

    let pairs: string[];

    if (Array.isArray(data)) {
      // Handle single pair [lon, lat]
      if (typeof data[0] === 'number') {
        const [lon, lat] = data as number[];
        return `POINT (${lon} ${lat})`;
      }

      // Handle array of pairs [[lon, lat], ...]
      pairs = (data as number[][]).map(coord => `${coord[0]},${coord[1]}`);
    } else {
      // Handle string input
      pairs = data.trim().split(';').map(pair => pair.trim());
    }

    if (pairs.length === 1) {
      const [lon, lat] = pairs[0].split(',').map(val => val.trim());
      return `POINT (${lon} ${lat})`;
    } else {
      const formattedPairs = pairs
        .map(pair => {
          const [lon, lat] = pair.split(',').map(val => val.trim());
          return `${lon} ${lat}`;
        })
        .join(', ');
      return `POLYGON ((${formattedPairs}))`;
    }
    }
    isPositiveWholeNumber(value: number): boolean {    
      return value !== null && value >= 1 && value % 1 === 0;
    }

    arePointsSame(p1: any, p2: any): boolean {
      // Convert string "lng,lat" to [lng, lat]
      if (typeof p1 === 'string') {
        p1 = p1.split(',').map(Number);
      }
      if (typeof p2 === 'string') {
        p2 = p2.split(',').map(Number);
      }

      // Validate both points
      if (!Array.isArray(p1) || !Array.isArray(p2) || p1.length < 2 || p2.length < 2) {
        return false;
      }

      // Exact comparison
      return p1[0] === p2[0] && p1[1] === p2[1];
    }

}
